<template lang="pug">
include /mixins
+b.g-row.--space_none
  +b.progress-bar
    +e.element
      +b.progress-ring2.SVG(ref="progressRing2" width="40" height="40")
        +b.progress-ring__circle.--under.CIRCLE(ref="progressRingCircle2" cx="20" cy="20" r="19")
    +b.progress-ring.SVG(ref="progressRing" width="40" height="40")
      +b.progress-ring__circle.CIRCLE(ref="progressRingCircle" cx="20" cy="20" r="19" stroke-linecap="round")
    +e.text-field
      +b.ds-caption.progress-num.P
        | {{percent + '%'}}
</template>
<script>
export default {
  name: 'ProgressBar',
  props: {
    percent: {
      default: 14,
      type: Number,
    },
  },
  data() {
    return {
    };
  },
  watch: {
    percent: function barPercentSet() {
      this.progressSettings()
    },
  },
  methods: {
    progressSettings() {
      const ringsData = this.$refs.progressRing;
      const circleData = this.$refs.progressRingCircle;
      // const ringsElement = ringsData;
      console.log(circleData.r);
      const radius = circleData.r.baseVal.value;
      const circumference = 2 * Math.PI * radius;
      const offset = circumference - (this.percent / 100) * circumference;
      ringsData.style.strokeDasharray = `${circumference} ${circumference}`;
      ringsData.style.strokeDashoffset = circumference;
      ringsData.style.strokeDashoffset = offset;
    },
  },
  mounted() {
    this.progressSettings();
  },
};
</script>
